module.exports = {
	"id": "CD",
	"name": "Congo, Democratic Republic of the",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.00055,
			"11": 0.02695,
			"12": 0.0011,
			"13": null,
			"14": 0.00165,
			"15": 0.00165,
			"16": 0.0011,
			"17": null,
			"18": 0.004125,
			"19": 0.00055,
			"20": 0.00055,
			"21": 0.00055,
			"22": 0.00055,
			"23": 0.000275,
			"24": null,
			"25": 0.00165,
			"26": 0.00275,
			"27": null,
			"28": 0.00055,
			"29": 0.011,
			"30": 0.0011,
			"31": 0.002475,
			"32": null,
			"33": 0.00385,
			"34": 0.0011,
			"35": 0.000825,
			"36": 0.000825,
			"37": 0.000825,
			"38": 0.004675,
			"39": 0.000825,
			"40": 0.003025,
			"41": 0.0011,
			"42": 0.0033,
			"43": 0.0374,
			"44": 0.000825,
			"45": 0.007975,
			"46": 0.0022,
			"47": 0.00715,
			"48": 0.0033,
			"49": 0.028325,
			"50": 0.006875,
			"51": 0.0363,
			"52": 0.024475,
			"53": 0.6545,
			"54": 0.147675,
			"55": 0.002475,
			"56": 0.00055,
			"57": null
		},
		"firefox": {
			"2": 0.000275,
			"3": 0.0187,
			"4": 0.001925,
			"5": 0.000825,
			"6": 0.000275,
			"7": 0.00055,
			"8": 0.001375,
			"9": 0.005225,
			"10": 0.000825,
			"11": 0.001925,
			"12": 0.00275,
			"13": 0.0022,
			"14": 0.006875,
			"15": 0.00165,
			"16": 0.003025,
			"17": 0.0011,
			"18": 0.000825,
			"19": 0.001375,
			"20": 0.002475,
			"21": 0.001925,
			"22": 0.0044,
			"23": 0.001375,
			"24": 0.00165,
			"25": 0.0011,
			"26": 0.0033,
			"27": 0.004125,
			"28": 0.001375,
			"29": 0.00165,
			"30": 0.00715,
			"31": 0.00275,
			"32": 0.00385,
			"33": 0.003575,
			"34": 0.00385,
			"35": 0.00385,
			"36": 0.001925,
			"37": 0.0044,
			"38": 0.005775,
			"39": 0.0044,
			"40": 0.01155,
			"41": 0.004675,
			"42": 0.00605,
			"43": 0.04675,
			"44": 0.00715,
			"45": 0.01045,
			"46": 0.008525,
			"47": 0.100375,
			"48": 0.083325,
			"49": 0.415525,
			"50": 0.014575,
			"51": 0.00275,
			"52": null,
			"3.5": 0.0033,
			"3.6": 0.003025
		},
		"opera": {
			"9": null,
			"11": 0.001925,
			"12": 0.0044,
			"15": 0.0011,
			"16": 0.00605,
			"17": 0.00055,
			"18": 0.001375,
			"19": 0.000825,
			"20": 0.001925,
			"21": 0.00165,
			"22": 0.00275,
			"23": null,
			"24": 0.00055,
			"25": 0.001375,
			"26": null,
			"27": 0.000825,
			"28": 0.000825,
			"29": 0.005225,
			"30": 0.0011,
			"31": 0.00055,
			"32": 0.0022,
			"33": 0.0077,
			"34": 0.001925,
			"35": 0.00275,
			"36": 0.006325,
			"37": 0.047575,
			"38": 0.0033,
			"39": 0.016775,
			"40": 0.09405,
			"41": 0.0121,
			"42": 0.000275,
			"43": null,
			"9.5-9.6": 0.00055,
			"10.0-10.1": 0.000275,
			"10.5": 0.001375,
			"10.6": 0.001925,
			"11.1": 0.0011,
			"11.5": 0.002475,
			"11.6": 0.01375,
			"12.1": 0.0066
		},
		"safari": {
			"0": null,
			"4": 0.00275,
			"5": 0.00275,
			"6": 0.00055,
			"7": 0.003575,
			"8": 0.0055,
			"9": 0.00715,
			"10": 0.016775,
			"3.1": null,
			"3.2": null,
			"5.1": 0.006875,
			"6.1": 0.001375,
			"7.1": 0.001925,
			"9.1": 0.0209
		},
		"ios_saf": {
			"8": 0,
			"10": 0.239327310575,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.00644959408826,
			"8.1-8.4": 0.0119153517902,
			"9.0-9.2": 0.00568438800999,
			"9.3": 0.0867233555371
		},
		"android": {
			"3": 0,
			"4": 0.0445038113695,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00556297642119,
			"4.1": 0.160531605297,
			"4.2-4.3": 0.401329013243,
			"4.4": 0.920275242248,
			"4.4.3-4.4.4": 0.928222351421
		},
		"ie": {
			"6": 0.000829217791411,
			"7": 0.00221124744376,
			"8": 0.0533463445808,
			"9": 0.00856858384458,
			"10": 0.0475418200409,
			"11": 0.154510915133,
			"5.5": null
		},
		"op_mob": {
			"0": 6.08290184483,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.16896949569
		},
		"edge": {
			"12": 0.0242,
			"13": 0.02805,
			"14": 0.01375
		},
		"ie_mob": {
			"10": 0.138067605634,
			"11": 0.562132394366
		},
		"bb": {
			"7": 0.0389,
			"10": null
		},
		"samsung": {
			"0": 0.418175
		},
		"and_uc": {
			"0": 2.1784
		},
		"op_mini": {
			"0": 81.9538786595
		},
		"and_chr": {
			"0": 2.46975
		},
		"and_ff": {
			"0": 0.029175
		}
	},
	"total": 99.3841581288
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CD.json
 ** module id = 490
 ** module chunks = 0
 **/